import { Button, Flex } from '@aloft/toolkit-sui';

import { useExportModal } from '../../ExportModal/useExportModal.tsx';
import { GuidedTourTooltip } from '../../GuidedTour/GuidedTourTooltip.tsx';
import { SUBNAV_HEIGHT } from '../consts.ts';
import { HeaderSubNavItem } from './HeaderSubNavItem.tsx';
import { APPRAISIFY_ONLY_ROUTES } from './constants.ts';
import { useActiveSubNav } from './useActiveSubNav.ts';

export const HeaderDesktopSubNavLegacy = () => {
  const subnav = useActiveSubNav();
  const { modal, openModal } = useExportModal();

  if (!subnav) return null;

  return (
    <Flex
      position="absolute"
      alignItems="center"
      top="3rem"
      height={SUBNAV_HEIGHT}
      width="100vw"
      marginLeft="-3rem"
      paddingLeft="3rem"
      zIndex={9}
      backgroundColor="surface1"
      borderStyle="solid"
      borderTopColor="strokeDefault"
      borderBottomColor="strokeDefault"
      borderTopWidth="1px"
      role="ul"
    >
      {subnav.map((item) => {
        if (APPRAISIFY_ONLY_ROUTES.includes(item.route)) {
          return null;
        }
        return <HeaderSubNavItem key={item.route} item={item} isLegacyLayout />;
      })}
      <GuidedTourTooltip
        text="Click 'Export' to export PDFs of your analysis or a file which can be imported directly into your form filling software."
        tourIndex={11}
        tourID="analysisTour"
      >
        <Button
          text="Export"
          onClick={openModal}
          size="sm"
          marginLeft="1rem"
          __testId="craftsman-export-button"
        />
      </GuidedTourTooltip>
      {modal}
    </Flex>
  );
};
